import { render } from "./HistoryTable.vue?vue&type=template&id=40475fed&scoped=true"
import script from "./HistoryTable.vue?vue&type=script&lang=js"
export * from "./HistoryTable.vue?vue&type=script&lang=js"

import "./HistoryTable.vue?vue&type=style&index=0&id=40475fed&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40475fed"]])

export default __exports__